<template>
    <div id="hy-swiper">
        <div class="swiper" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" ref="swiper">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Swiper",
        props: {
            interval: {
                type: Number,
                default: 3000
            },
            //轮播图滚动切换页面过渡效果的时间长度
            animDuration: {
                type: Number,
                default: 300
            },
            moveRatio: {
                type: Number,
                default: 0.25
            },

        },
        data:function(){
            return{
                slideCount:0,
                totalWidth:0,
                currentIndex:1,
                swiperStyle:{},
                Scrolling:false,
            }
        },
        mounted:function () {
            setTimeout(()=>{
                this.handleDom();
                this.startTimer();
            },3000)
        },
        methods:{
            startTimer:function(){
                this.playTimer=window.setInterval(()=>{
                    this.currentIndex++;
                    this.scrollContent(-this.currentIndex*this.totalWidth);
                },this.interval)
            },
            stopTimer:function(){
                window.clearInterval(this.playTimer)
            },
            scrollContent:function(currentPosition){
                this.scrolling=true;
                this.swiperStyle.transition ='transform '+ this.animDuration + 'ms';
                this.setTransform(currentPosition);
                this.checkPosition();
                this.scrolling=false;
            },
            checkPosition:function(){
                window.setTimeout(()=>{
                    this.swiperStyle.transition='0ms';
                    if(this.currentIndex>=this.slideCount+1){
                        this.currentIndex=1;
                        this.setTransform(-this.currentIndex*this.totalWidth);
                    }else if(this.currentIndex<=0){
                        this.currentIndex=this.slideCount;
                        this.setTransform(-this.currentIndex*this.totalWidth);
                    }
                },this.animDuration)
            },
            setTransform: function (position) {
                this.swiperStyle.transform = `translate3d(${position}px, 0, 0)`;
                this.swiperStyle['-webkit-transform'] = `translate3d(${position}px), 0, 0`;
                this.swiperStyle['-ms-transform'] = `translate3d(${position}px), 0, 0`;
            },

            handleDom:function () {
                let swiperE1=this.$refs.swiper;
                let slidesE1s =swiperE1.children;
                // let swiperE1=document.querySelector('.swiper');
                // let slidesE1s =swiperE1.getElementsByClassName('slide');
                this.slideCount=slidesE1s.length;

                if(this.slideCount>1){
                    let cloneFirst=slidesE1s[0].cloneNode(true);
                    let cloneLast=slidesE1s[this.slideCount -1].cloneNode(true);
                    swiperE1.insertBefore(cloneLast,slidesE1s[0]);
                    swiperE1.appendChild(cloneFirst);
                    this.totalWidth=swiperE1.offsetWidth;
                    this.swiperStyle=swiperE1.style;
                }
                this.setTransform(-this.totalWidth)
            },
            touchStart: function (e) {
                // 1.如果正在滚动, 不可以拖动
                if (this.scrolling) return;

                // 2.停止定时器
                this.stopTimer();

                // 3.保存开始滚动的位置
                this.startX = e.touches[0].pageX;
            },

            touchMove: function (e) {
                // 1.计算出用户拖动的距离
                this.currentX = e.touches[0].pageX;
                this.distance = this.currentX - this.startX;
                let currentPosition = -this.currentIndex * this.totalWidth;
                let moveDistance = this.distance + currentPosition;

                // 2.设置当前的位置
                this.setTransform(moveDistance);
            },

            touchEnd: function (e) {
                // 1.获取移动的距离
                let currentMove = Math.abs(this.distance);

                // 2.判断最终的距离
                if (this.distance === 0) {
                    return
                } else if (this.distance > 0 && currentMove > this.totalWidth * this.moveRatio) { // 右边移动超过0.5
                    this.currentIndex--
                } else if (this.distance < 0 && currentMove > this.totalWidth * this.moveRatio) { // 向左移动超过0.5
                    this.currentIndex++
                }

                // 3.移动到正确的位置
                this.scrollContent(-this.currentIndex * this.totalWidth);

                // 4.移动完成后重新开启定时器
                this.startTimer();
            },
        }
    }
</script>

<style scoped>
    #hy-swiper {
        overflow: hidden;
        position: relative;
    }

    .swiper {
        display: flex;
    }

    .indicator {
        display: flex;
        justify-content: center;
        position: absolute;
        width: 100%;
        bottom: 8px;
    }

    .indi-item {
        box-sizing: border-box;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: #fff;
        line-height: 8px;
        text-align: center;
        font-size: 12px;
        margin: 0 5px;
    }

    .indi-item.active {
        background-color: rgba(212,62,46,1.0);
    }
</style>

















